import { Model } from '@/clients/http'

export interface CatalogueFeedStatus {
  item_count: number
  in_stock_count: number
  out_of_stock_left_out: number
  skipped: { id: string; title: string; reason: string }[]
}

export class CatalogueFeedModel extends Model {
  public static readonly correlations = {
    STATUS: 'GET_CATALOGUE_FEED_STATUS',
  }

  public static readonly endpoints = {
    status: () => this.createEndpoint({ url: '/api/backoffice/catalogue-feed/status' }),
  }

  /** What the feed holds right now: products in it, out-of-stock ones left out, and products skipped with why. */
  public static readonly getStatus = async () =>
    this.createHttpRequest<{ result: CatalogueFeedStatus }, { message?: string }>({
      correlationKey: this.correlations.STATUS,
      payload: { method: 'get', url: this.endpoints.status(), useBearerToken: true },
    })
}
